import { render } from "./OcrReport.vue?vue&type=template&id=a9b100cc"
import script from "./OcrReport.vue?vue&type=script&lang=js"
export * from "./OcrReport.vue?vue&type=script&lang=js"

import "./OcrReport.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__